import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import _ from 'underscore'

import 'kendo'

import {AgGridReact} from 'ag-grid-react'
import 'ag-grid-root/dist/styles/ag-grid.css'
import './styles/ag-grid.css'
import './styles/trading_widgets.css'

import NumericTextBox from './components/react-numerictextbox'

function formatNumeric(value, format) {
	if (value === undefined)
			return '';
	if (isNaN(value))
			return '';
	if (format === undefined) {
			format = '0,0[.][0]0000000'
	}
	return numeral(value).format(format)
}

function formatLimitPx(value) {
	if (value === undefined)
			return 'MKT';
	return numeral(value).format('0,0[.][0]0000000')
}


function canCancel(order) {
    var shortenStatus = status_shortcode(order.order_status, order);
    return (shortenStatus == "NEW" || shortenStatus == "PF"  || shortenStatus == "RR" || shortenStatus == "CR" || shortenStatus == "RP" )
}
function canReplace(order) {
    var shortenStatus = status_shortcode(order.order_status, order);
    return (shortenStatus == "NEW" || shortenStatus == "PF"  || shortenStatus == "RR" || shortenStatus == "CR" || shortenStatus == "RP" )
}
const ORDER_GRID_COLUMNS = [
	{headerName: '#',field: "order_id",width: 70,suppressMenu: true,suppressResize: true, cellRenderer: (d) => {return "<span class='ident'>"+d.value+"</span>"},},
	{headerName: 'Status',field: "order_status",width: 70, cellClass: 'statuscol',suppressMenu: true,
							 cellRenderer: (dataContext) => {
								 if (dataContext.data['updated']) {
									 dataContext.eGridCell.classList.remove("updated")
									 dataContext.eGridCell.classList.add("updated")
									 if (dataContext.tmrRefesh) clearTimeout(dataContext.tmrRefesh)
									 dataContext.tmrRefesh = setTimeout(() => {
										 dataContext.eGridCell.classList.remove("updated")
									 }, 400)
									 setTimeout(() => { delete dataContext.data['updated']; }, 1)
								 }
								 let shorten_val = status_shortcode(dataContext.value, dataContext.data)
								 return "<span class='status " + shorten_val + "'>" + shorten_val + "</span>"
							 }
	},
	{headerName: 'Time',field: "create_datetime",width: 70, cellClass: 'cellTime multiline',
							 cellRenderer: (dataContext) => {
									let value = dataContext.value
									let html = '';
									let time = moment(moment.utc(value).toDate());
									if (time.isValid()) {
										let showDate = time.isBefore(moment().startOf('day'))
											html += "<span style='" + (showDate ? "" : "display: block;margin-top: 0.5em;") + "'>" + time.format("HH:mm:ss") + "</span>";
											if (showDate)
													html += "<br/><span class='footnote'>" + time.format("YYYY-MM-DD") + "</span>";
									} else
											html += "<span class=''>" + value + "</span>";
									return html;
							 }
	},
	{headerName: 'Trader',field: "trader",width: 70},
	{headerName: 'Side',field: "side",width: 60,cellClass: (d) => { return (d.value == "BUY" ? "positive cellCenter" : "negative cellCenter") },
							 cellRenderer: (dataContext) => {
								 let value = dataContext.value
								 if (value == "SELL_SHORT") return "<span>SELL<span class='footnote'> short</span></span>";

								 return value
							 }
	},
	{headerName: 'Security',field: "symbol",width: 150, cellClass: 'multiline',
							 cellRenderer: (dataContext) => {
									// if (!(dataContext.InstrumentId))
									//     return "<div class='alarming'>UNALLOCATED</div>";
									var html = '';
									// html += "<span class=''><a href='/statics/instinfo?InstrumentId=" + dataContext['InstrumentId'] + "' target='_instinfo'>" + value + "</a></span>";
									html += "<span class=''>" + (dataContext.data['pricefeed_description'] || dataContext.value) + "</span>";
									html += "<br/><span class='footnote'>" + dataContext.value + "</span>";
									return html;
							 }
	},
	{headerName: 'Quantity',field: "quantity",width: 70,cellClass:"cellRight",suppressMenu: true,cellRenderer:(d) => {
			return formatNumeric(d.value)
	}},
	{headerName: 'LimitPrice',field: "limit_price",width: 70,suppressMenu: true,cellClass: "cellPrice", cellRenderer: (d) => {return formatLimitPx(d.value)}},
	// Price Feed Quote ==================
	{headerName: 'Bid',colId:"pxBid",field: "pricefeed_bid",width: 70,cellClass:"cellRight multiline",suppressSorting:true,suppressMenu: true,cellRenderer:(d) => {
			var html = '';  //d.data["pricefeed_bid"]=120.12; d.data["pricefeed_bid_size"] = 1203;
			html += "<span class='bid'>" +
							formatNumeric(d.data["pricefeed_bid"],'0[.][0]0000000') + "</span>";
			html += "<br/><span class='footnote' style='bottom: 1px; right: 5px;'>"
							+ formatNumeric(d.data["pricefeed_bid_size"]) + "</span>";
			return html;
	}},
	{headerName: 'Ask',colId:"pxAsk",field: "pricefeed_ask",width: 70,cellClass:"cellRight multiline",suppressSorting:true,suppressMenu: true,cellRenderer:(d) => {
			var html = '';  //d.data["pricefeed_ask"]=120.12; d.data["pricefeed_ask_size"] = 1203;
			html += "<span class='ask'>" +
							formatNumeric(d.data["pricefeed_ask"],'0[.][0]0000000') + "</span>";
			html += "<br/><span class='footnote' style='bottom: 1px; right: 5px;'>"
							+ formatNumeric(d.data["pricefeed_ask_size"]) + "</span>";
			return html;
	}},
	{headerName: 'Last',colId:"pxLast",field: "pricefeed_last",width: 70,cellClass:"cellRight multiline",suppressSorting:true,suppressMenu: true,cellRenderer:(d) => {
			var html = '';  //d.data["pricefeed_last_price"]=120.12; d.data["pricefeed_size_last_trade"] = 1203;
			html += "<span style='color: #FFFAC3' class='bid' title='&#9719; "+d.data["pricefeed_last_datetime"]+"'>" +
							formatNumeric(d.data["pricefeed_last_price"],'0[.][0]0000000') + "</span>";
			html += "<br/><span class='footnote' style='bottom: 1px; right: 5px;'>"
							+ formatNumeric(d.data["pricefeed_size_last_trade"]) + "</span>";
			return html;
	}},
	{headerName: 'CCY',field: "instrument.ccy",width: 55,cellClass:"cellCenter"},

	{headerName: 'Sector',field: "pricefeed_sector",width: 100,},
	// =======================================
	{headerName: 'Exchange',field: "instrument.exchange_mic",width: 60,cellClass:"cellCenter"},
	{headerName: 'CumQty',field: "filled_quantity",width: 70,cellClass:"cellRight",suppressMenu: true,cellRenderer:(d) => {
			return formatNumeric(d.value)
	}},
	{headerName: 'LeavesQty',field: "leaves_quantity",width: 70,cellClass:"cellRight",suppressMenu: true,cellRenderer:(d) => {
			return formatNumeric(d.value)
	}},
	{headerName: 'Done',field: "filled_quantity",width: 70,cellClass:"cellMeter",suppressMenu: true,
		comparator: (k,j,a,b) => {
			let pctA = 0
			let pctB = 0
			try { pctA = (+(k)) / (+(a.data['quantity'])) * 100; } catch(e) { pctA = 999 }
			try { pctB = (+(j)) / (+(b.data['quantity'])) * 100; } catch(e) { pctB = 999 }
			return pctA - pctB
		},
		cellRenderer:(d) => {
			let pct = 0
			try { pct = (+(d.value)) / (+(d.data['quantity'])) * 100; } catch(e) { pct = 101 }

			if (d.data.is_booked == false && (d.data.is_complete == false || pct > 100)) {
				let html = ''
				html += "<div class='meter " + (pct == 100 && d.data['updated'] ? 'completed' : '') + "'>"
				if (pct > 0)
						html += "<span class='bar " + (pct > 100 ? 'alarming' : '') + "' style='width: " + pct + "%''></span> \
										<span class='pct " + (pct > 100 ? 'alarming' : '') + "' style='left: " + pct + "%''>" + formatNumeric(pct,'0[.]') + "%</span>"
						html += "</div>"
				return html
			} else {
				if (d.data.is_booked === true) { // && (d.data.filled_quantity == 0 || d.data.filled_quantity == undefined )) {
					return "<span style='color:#93C763;margin-left: 2em'> &#10003;</span>"
				}
				if (d.data.is_booked == false && !(d.data.filled_quantity == 0 || d.data.filled_quantity == undefined) ) {
					return "<span style='color:#ffa900;margin-left: 2em'> ϟ</span>"
				}
				return ''
			}

			return ''
	}},
	{headerName: 'AvgPrice',field: "filled_avg_price",width: 70,cellClass:"cellPrice",suppressSorting:true,suppressMenu: true,cellRenderer:(d) => {
			return formatNumeric(d.value,'0[.][0]0000000')
	}},
	{headerName: 'MarketConnector',field: "market_connector",width: 120},
	{headerName: 'OrderType',field: "order_type",width: 90,cellClass:"cellCenter"},

	{headerName: 'TIF',field: "timeinforce",width: 50, cellClass:"cellCenter",cellRenderer: (d) => {return shortenTIF(d.value)}},
//	{headerName: 'Account',field: "account_id",width: 10},
	{headerName: 'ClOrdID',field: "clOrdId",width: 100,cellClass:"cellText"},
	{headerName: 'Text',field: "text",width: 150,cellClass:"cellText"},
	{headerName: 'Algo',field: "algo",width: 150,cellClass:"cellText", cellRenderer:(d) => {
			return JSON.stringify(d.value)
	}},
]

// pricefeed last quote map
let _pxQuotes = {}

export default class EMSMonitor extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loaded : false,
			orders : [],
			selectedOrder : {},
			selectedOrderExecutions : {},
			selectedOrderAllocations : {},

			savedLayout : props.savedLayout || {},
		}

		// websocket connections
    	this.sockets = []

		// delayed grid refreshing nodes
		this._pendingRefreshNodes = {}
	}

	componentDidMount() {
    // Layout
    $(this.refs.splitPanel).kendoSplitter({
        orientation: "vertical",
        panes: [
            { collapsible: false },
            { collapsible: true, size: this.state.savedLayout.inspector_pane_size || '25%', min: "16px" }
        ],
        resize: (e) => {
					this.state.savedLayout.inspector_pane_size = $(this.refs.splitPanel).data("kendoSplitter").size("> .k-pane:last")
					this.saveLayout()
            // self.refs.slickGrid.handleResize();
        }
    });
    $(this.refs.paneTools).kendoSplitter({
        orientation: "vertical",
        panes: [
            { collapsible: false, resizable: false, size: '43px' },
            { collapsible: false },
        ]
    });
    $(this.refs.ticketinspector).kendoSplitter({
        panes: [
            { collapsible: false },
            { collapsible: true, size: '30%' },
        ]
    });

    // subscribe to realtime Feed
    realtime().then( (socket) => {
			socket.onclose = (e) => {
				if (e.wasClean != true)
					raiseAlert("CONNECTION LOST: " + e.code + " " + e.reason)
			}
   		socket.onjson = (message) => {
				if (message.execution_id) {
					//this is an execution message
					console.log("ER ==> ", message)
					let order_id = message.order_id
					let orderNode = undefined
					this.orderGrid.forEachNode( (node) => {
						let data = node.data
						if (data.order_id == order_id) {
							orderNode = node
						}
					})
					if (orderNode) {
						Object.assign(orderNode.data, {
							order_status : message.order_status,
							filled_quantity : message.filled_quantity || orderNode.data.filled_quantity,
							filled_avg_price : message.filled_avg_price || orderNode.data.filled_avg_price,
						})
						orderNode.data.updated = true
						this._pendingRefreshNodes[orderNode.id] = orderNode
						this.refreshChanges()

						//selected order?
						if (this.state.selectedOrder.order_id == order_id) {
							let execs = _.union(this.state.selectedOrderExecutions, [message])
							execs.sort( (a,b) => a.execution_id - b.execution_id )
							this.setState({
								selectedOrderExecutions : execs
							})
						}
					}
				} else if (message.clOrdId) {
					// this is an order message
					console.log("Order ==> ", message)
					delete message.executions
					delete message.allocations

					// JSON fields
					try { message.instrument = JSON.parse(message.instrument) } catch(e) {}
					try { message.props = JSON.parse(message.props) } catch(e) {}
					try { message.algo = JSON.parse(message.algo) } catch(e) {}

					if (!(message.trader)) delete message.trader
					message.text = message.memo
					delete message.memo
					message.updated = true
					// find order
					let orderNode = undefined
					this.orderGrid.forEachNode( (node) => {
						let data = node.data
						if (data.clOrdId == message.clOrdId)
							orderNode = node
					})
					if (orderNode) {
						Object.assign(orderNode.data, message)
						this._pendingRefreshNodes[orderNode.id] = orderNode
						this.refreshChanges()
						if (this.state.selectedOrder.order_id == message.order_id)
							this.forceUpdate()
					} else {
						// add as new  // TODO: conflation for batch new orders
						this.state.orders.push(message)
						this.subscribeSymbol(message.symbol, message)
						this.orderGrid.setRowData(this.state.orders)
						// auto scroll
						let viewport = $("#paneTickets .ag-body-viewport")
						let offset = viewport[0].scrollHeight - viewport[0].scrollTop - viewport.height()
						if (offset <= 38)
							viewport.scrollTop(viewport[0].scrollHeight)
					}
				}
      }
			this.sockets.push(socket)
      socket.subscribe("order.Order")
      socket.subscribe("order.Execution")
    }).catch( (err) => { console.log(err) })

		// load initial order collection
		api('/order')
		  .then( (res) => {
				if (res == null || res == undefined)
					res = []
				if (Array.isArray(res)) {
					res.sort( (a,b) => a.order_id - b.order_id )
					this.setState({
						orders : res,
						loaded : true,
					}, () => {
						this.orderGrid.setRowData(this.state.orders)
						this.state.orders.forEach( (o) => {
							this.subscribeSymbol(o.symbol)
						})
						this.setState({loaded:true}, () => {
							setTimeout( () => {
								// scroll to bottom
								let lastNode = undefined
								this.orderGrid.forEachNodeAfterFilterAndSort( (node) => {
									lastNode = node
								})
								if (lastNode) this.orderGrid.ensureNodeVisible(lastNode)
							}, 10)
						})
					})
				}
		  })
	}

	componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close()
    }
    delete this.sockets
		delete this._px_socket
		_pxQuotes = {}
	}

	subscribeSymbol(symbol, order) {
		symbol = symbol.trim()
		if (symbol == ""  || _pxQuotes.hasOwnProperty(symbol)) {
			let quote = _pxQuotes[symbol]
			if (quote && order && quote.description) {
				this.processPriceTick(quote, order)
			}
			return
		} else {
			_pxQuotes[symbol] = {}
		}

		let socket = this._px_socket
		if (!socket) {
			this._px_socket = {}
			realtime().then( (socket) => {
				this._px_socket = socket
				this._px_socket_ready = true
				socket.onjson = (res) => {
					let symbol = res.symbol
					console.log(symbol, res)
					if (_pxQuotes[res.symbol])
						Object.assign(_pxQuotes[res.symbol], res)

					if (! this._pendingPriceCells) this._pendingPriceCells = {}
					this.orderGrid.forEachNode( (node) => {
						let data = node.data;
						if (data.symbol == symbol) {
							this.processPriceTick(res, data)
							this._pendingPriceCells[node.id] = node
						}
					})

					if (this._pendingPriceCellsTimer == undefined) {
						this._pendingPriceCellsTimer = setTimeout(() => {
							this.orderGrid.refreshCells({
								rowNodes: _.values(this._pendingPriceCells),
								columns: ["pxBid","pxAsk","pxLast",]
							})
							this._pendingPriceCells = {}
							this._pendingPriceCellsTimer = undefined
						}, 150)
					}
				}
				this.sockets.push(socket)
				for (let sym in _pxQuotes) {
					socket.subscribe("pricefeed.Quote.RIC:" + sym)
				}
			}).catch( (err) => { console.log(err) })
		} else {
			if (socket.subscribe != undefined)
				socket.subscribe("pricefeed.Quote.RIC:" + symbol)
		}

		// Get initial
		api('/quote?symbol='+symbol)
		.then( (res) => {
			Object.assign(_pxQuotes[symbol], res)
			console.log(symbol, "INITIAL => ", res)
			let refreshNodes = []
			this.orderGrid.forEachNode( (node) => {
				let data = node.data;
				if (data.symbol == symbol) {
					this.processPriceTick(res, data)
					this._pendingRefreshNodes[node.id] = node
				}
			})
			this.refreshChanges()
		}).catch( (e) => {} )
	}
	processPriceTick(quote, order) {
		if (quote.description) order["pricefeed_description"] = quote.description
		if (quote.sector) order["pricefeed_sector"] = quote.sector
		if (quote.crncy) order["pricefeed_crncy"] = quote.crncy
		if (quote.last_datetime) order["pricefeed_last_datetime"] = moment(quote.last_datetime).format("HH:mm:ss")
		if (quote.bid) order["pricefeed_bid"] = quote.bid
		if (quote.bid_size) order["pricefeed_bid_size"] = quote.bid_size
		if (quote.ask) order["pricefeed_ask"] = quote.ask
		if (quote.ask_size) order["pricefeed_ask_size"] = quote.ask_size
		if (quote.last_price && quote.size_last_trade) {
			order["pricefeed_last_price"] = quote.last_price
			order["pricefeed_size_last_trade"] = quote.size_last_trade
		}
	}

	refreshChanges(columns) {
		if (this._pendingRefreshNodesTimer == undefined) {
			this._pendingRefreshNodesTimer = setTimeout(() => {
				this.orderGrid.refreshCells({
					rowNodes: _.values(this._pendingRefreshNodes),
					columns: columns
				})
				this._pendingRefreshNodes = {}
				this._pendingRefreshNodesTimer = undefined
			}, 150)
		}
	}

	saveLayout() {
		if (window.updateLayout) {
			window.updateLayout(this.state.savedLayout)
		}
	}

	render() {
		return (
      <div ref="splitPanel" style={{ height: '100%', width: '100%', position: 'absolute'}}>
          <div ref="paneTickets" id="paneTickets">
              <div ref="datagridContainer" className="ag-grid" style={{ height: '100%', width: '100%', position: 'relative'}}>
								<AgGridReact ref="orderDataGrid"
									onGridReady={ (args) => { this.orderGrid = args.api; this.orderGridColumns = args.columnApi; /* args.api.sizeColumnsToFit() */
										if(localStorage.EMSMonitorColState ){
											console.log("Saved EMS Grid State: " ,localStorage.EMSMonitorColState )
											try{
												console.log("Loading Saved EMS Grid State")
												this.orderGridColumns.setColumnState(JSON.parse(localStorage.EMSMonitorColState))
												console.log("Saved EMS Grid State Loaded")
										} catch(e) { console.log(e); return; }
										}
									}
								}
	                // onGridReady={ (args) => { this.orderGrid = args.api; /* args.api.sizeColumnsToFit() */ } }
	                gridOptions={{
	                    enableColResize: true,
											suppressScrollOnNewData: true,
											suppressLoadingOverlay: true,
											suppressFocusAfterRefresh: true,
						getContextMenuItems: (params) => {
							console.log("CREATE MENU", params)
							var result = []

							var selectedOrders = params.api.getSelectedNodes()
							if (selectedOrders.length <= 1 && params.node) {

								let item = params.node.data
								result = [
									{ name: '[' + item.trader + ']: ' + item.side[0] + ' ' + item.quantity + ' ' + item.symbol + (item.limit_price ? ' @ ' + item.limit_price : ' @ MKT'),disabled:true },
									'separator'
								]

								result.push({
									name: `Open...`,
									action: function () { raiseWidget('OrderTicket', {
										order	:	item,
									}) },
								})
							}

							if (selectedOrders.length > 0) {
								let text = "Order[" + selectedOrders[0].data.order_id + "]"
								if (selectedOrders.length > 1) text = "" + selectedOrders.length + " Orders"
								result.push({
										name: 'Copy ' + text + ' To Clipboard',
										action: function () { params.api.copySelectedRowsToClipboard(true) }
								})

								result.push('separator')

								result.push({
										name: 'Cancel ' + text + '',
										action: function () {
											let q = Promise.resolve()
											selectedOrders.forEach((ord) => {
												q.then(
													api('/order?clOrdId='+ord.data.clOrdId, {
														method: 'DELETE'
													}).then((e) => console.log(e))
													.catch((e) => console.log(e))
												)
											})
										}
								})

								result.push({
										name: 'DoneForDay ' + text + '',
										action: function () {
											let q = Promise.resolve()
											selectedOrders.forEach((ord) => {
												q.then(
													api('/order', {
														method: 'PUT',
														body : JSON.stringify({
																clOrdId: ord.data.clOrdId,
																order_status: "DONE_FOR_DAY"
														})
													}).then((e) => console.log(e))
													.catch((e) => console.log(e))
												)
											})
										}
								})
							}

							result.push('separator')
							result.push({
									name: 'Export All As CSV...',
									action: function () { params.api.exportDataAsCsv({fileName: "Orders_"+moment().format('YYYY_MM_DDTHH_mm_ss')}) }
							})

							result.push({
								name: 'Save Column Layout..',
								action: function () {
									//Save Column Layout
									try{
										var colState = JSON.stringify(params.columnApi.getColumnState())
										console.log("EMS colState: ", colState)
										localStorage.EMSMonitorColState = colState
								} catch(e) { console.log(e); return; }
								 }
							})

							return result
						},
	                }}
	                columnDefs={ORDER_GRID_COLUMNS}
							    rowSelection="multiple"
							    enableSorting="true"
							    enableFilter="true"
							    rowHeight="32"
									toolPanelSuppressValues="true"
									toolPanelSuppressRowGroups="true"
									toolPanelSuppressPivotMode="true"
									toolPanelSuppressPivots="true"
									onRowSelected={ (event) => {
										if (event.node.selected !== true) return
										if (event.node.data.order_id) {
											this.setState({
												selectedOrder : event.node.data,
												selectedOrderExecutions : [],
												selectedOrderAllocations : [],
											})
											console.log("selected => ", event.node.data)
											api('/order/execution?clOrdId='+event.node.data.clOrdId)
												.then( (res) => {
													if (Array.isArray(res)) {
														res.sort( (a,b) => a.execution_id - b.execution_id )
														this.setState({
															selectedOrderExecutions : res
														})
													}
												})
											api('/order/allocation?clOrdId='+event.node.data.clOrdId)
												.then( (res) => {
													if (Array.isArray(res)) {
														this.setState({
															selectedOrderAllocations : res
														})
													}
												})
										}
									}} />
              </div>
              { this.state.loaded ? undefined : <div className="loader"></div> }
          </div>
          <div ref="paneTools">
              <div ref="plugin1">
                  <div className="panel-heading">
                      <a>
                        <span>{ (this.state.selectedOrder.order_id ?
																	this.state.selectedOrder.side[0] + ' '
																			+ this.state.selectedOrder.quantity + ' '
																			+ this.state.selectedOrder.symbol
																			+ (this.state.selectedOrder.limit_price ? ' @ ' + this.state.selectedOrder.limit_price : ' @ MKT')
                                 : 'Order Inspector') }</span>
                      </a>
                  </div>
                  <div ref="pluginOrderReplaceBar" className="panel-collapse collapse in">
                      <div className="panel-body" style={{ overflow: 'visible' }}>
                          <div className="OrderReplaceBar" style={{ height: '100%', marginTop: '-1.2em' }}>
{ (this.state.selectedOrder.order_id ?
            <div className="orderbar">
                <div className="control" style={{fontSize: 13}}>
                    <span className={ "label label-" + ( this.state.selectedOrder.side[0].toLowerCase() === 'b' ? 'buy' : 'sell' ) } >
                    { this.state.selectedOrder.side }
                    </span> <label>{ this.state.selectedOrder['pricefeed_description'] || this.state.selectedOrder.symbol }</label> &nbsp; &nbsp;
                </div>
                <div className="control">
                    <a className={"btn btn-danger btn-xs " + (canCancel(this.state.selectedOrder) ? '' : 'disabled') }
                       onClick={ () => {
	 												 api('/order?clOrdId='+this.state.selectedOrder.clOrdId, {
	 															method: 'DELETE'
	 														})
	 													  .then( (res) => {
	 															console.log(res)
	 													    if (res.detail) {
	 																raiseAlert(res.detail)
	 															}
	 													  })
                       } }>CXL</a>
                </div>
                <div className="control">
                    &nbsp;|&nbsp;
                </div>
                <div className="control">
                    <span className="label">Quantity</span>
                    <NumericTextBox ref="txtQuantity" style={{ width : '10em' }} decimals={0} format='n0' min={0}
                                    initialValue={ this.state.selectedOrder.quantity } />
                </div>
                <div className="control">
                    <span className="label">Limit Price</span>
                    <NumericTextBox ref="txtLimitPrice" style={{ width : '8em' }} decimals={5} format='#,#.########' min={0}
                                    step={ _pxQuotes[this.state.selectedOrder.symbol] && _pxQuotes[this.state.selectedOrder.symbol].tick_size ?
                                             _pxQuotes[this.state.selectedOrder.symbol].tick_size
                                           : 0.01 }
                                    initialValue={ this.state.selectedOrder.limit_price } disabled={ ( this.state.selectedOrder.limit_price ? false : true ) } />
                </div>
                <div className="control">
                    <a className={"btn btn-info btn-xs " + (canReplace(this.state.selectedOrder) ? '' : 'disabled') }
                       onClick={ () => {
													 let changes = {
														 clOrdId: this.state.selectedOrder.clOrdId,
													 }
	                         changes.quantity = this.refs.txtQuantity.getValue();
	                         changes.limit_price = this.refs.txtLimitPrice.getValue();
													 if (!(changes.limit_price)) delete changes.limit_price

													 api('/order', {
																method: 'PUT',
																body : JSON.stringify(changes)
															})
														  .then( (res) => {
																console.log(res)
														    if (res.detail) {
																	raiseAlert(res.detail)
																}
														  })
                       } }>RPL</a>
                </div>
            </div>
    :   '') }
                          </div>
                      </div>
                  </div>
              </div>
              <div ref="plugin2" id="plugin2">
                          <div ref="ticketinspector" style={{height: '100%', width: '100%'}}>
                            <div className="orderexecitionspanel" style={{ overflow: 'auto' }}>
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <td style={{ width: '8em'}}>Ver. Broker ID</td>
                                  <td style={{ width: '6em'}}>Time</td>
                                  <td style={{ width: '6em'}}>Type</td>
                                  <td style={{ width: '6em'}}>Status</td>
                                  <td>Qty</td>
                                  <td>Price</td>
                                  <td>CumQty</td>
																	<td>LeavesQty</td>
                                  <td>AvgPrice</td>
                                  <td>LastMkt</td>
                                  <td>Text</td>
                                </tr>
                              </thead>
                              <tbody>
                                { _.map(this.state.selectedOrderExecutions, (exe) => {
                                      return (
			                                <tr key={ exe.execution_id }>
			                                  <td className="idcol" title={ '[' + exe.version + '] ' + (exe.broker_exec_id || '') }>
																					<div style={{ width: '8em', opacity: 0.4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow:'ellipsis' }}>
																					{ '[' + exe.version + '] ' + (exe.broker_exec_id || '') }
																					</div>
																				</td>
			                                  <td className="timecol" style={{ fontFamily: 'Open Sans Condensed', textAlign: 'center'}}>{
			                                        (exe.broker_exec_datetime ? moment(moment.utc(exe.broker_exec_datetime).toDate()).format("HH:mm:ss.SSS") : '')
			                                         }</td>
			                                  <td className={ "status " + status_shortcode(exe.exec_type) } style={{ textAlign: 'center'}}>{
			                                        status_shortcode(exe.exec_type) }</td>
			                                  <td className={ "status " + status_shortcode(exe.order_status) } style={{ textAlign: 'center'}}>{
			                                        status_shortcode(exe.order_status) }</td>
			                                  <td style={{ textAlign: 'right'}}>{
			                                        formatNumeric(exe.quantity) }</td>
			                                  <td className="cellPrice" style={{ textAlign: 'right'}}>{
			                                        formatNumeric(exe.price) }</td>
			                                  <td style={{ textAlign: 'right'}}>{
			                                        formatNumeric(exe.cum_quantity) }</td>
																				<td style={{ textAlign: 'right'}}>{
			                                        formatNumeric(exe.leaves_quantity) }</td>
			                                  <td className="cellPrice" style={{ textAlign: 'right'}}>{
			                                        formatNumeric(exe.avg_price) }</td>
			                                  <td>{ exe.lastmkt }</td>
			                                  <td style={{ fontStyle:'italic', whiteSpace: 'nowrap'}}>{
			                                        exe.text }</td>
			                                </tr> )
                                  })
                                }
                              </tbody>
                            </table>
                            </div>
                            <div className="allocspanel" style={{ overflow: 'auto' }}>
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <td>Book Name</td>
                                  <td>Tag</td>
                                  <td>Quantity</td>
                                </tr>
                              </thead>
                              <tbody>
                                { _.map(this.state.selectedOrderAllocations, (alloc) => {
                                      return (
			                                <tr key={ alloc.allocation_id }>
			                                  <td className="idcol" style={{ opacity: 0.6 }}>{ alloc.book_name }</td>
			                                  <td className="idcol" style={{ opacity: 0.6 }}>{ alloc.tag }</td>
			                                  <td className="idcol" style={{ opacity: 0.6 }}>{ alloc.quantity }</td>
			                                </tr>)
                                    })
                                }
                              </tbody>
                            </table>
                            </div>
                          </div>
                      </div>
          </div>
      </div>)
	}
}

function shortenTIF(TIF){
    switch (TIF) {
        case 'AT_THE_OPENING' :
            return 'OPEN';
        case 'AT_THE_CLOSE' :
        	return 'CLOSE';
        case 'FILL_OR_KILL' :
        	return 'FOK';
        case 'IMMEDIATE_OR_CANCEL' :
        	return 'IOC';
        case 'GOOD_TILL_CANCEL' :
        	return 'GTC';
        default:
	        return TIF;
    }
}

function status_shortcode(execType, order){
    switch (execType) {
        case 'PARTIAL_FILL' :
        case 'PARTIALLY_FILLED' :
            return 'PF';
        case 'FILL' :
        case 'FILLED' :
            return 'F';
        case 'DONE_FOR_DAY' :
            return 'DD';
        case 'TRADE_CANCEL' :
        case 'CANCELED' :
            return 'X';
        case 'CANCELLED' :
            return 'X';
        case 'REPLACE' :
            return 'RP';
        case 'REPLACED' :
            return 'RP';
        case 'PENDING_CANCEL' :
            return 'PC';
        case 'STOPPED' :
            return 'STOPPED';
        case 'REJECTED' :
            return 'R';
        case 'SUSPENDED' :
            return 'SUSPENDED';
        case 'PENDING_NEW' :
            return 'PN';
        case 'CALCULATED' :
            return 'CALCULATED';
        case 'EXPIRED' :
            return 'EXPIRED';
        case 'RESTATED' :
            return 'RESTATED';
        case 'PENDING_REPLACE' :
            return 'PR';
        case 'ORDER_STATUS' :
            return 'OS';
        case 'ORDER_SENT' :
            return 'SENT';
        case 'ORDER_RECEIVED' :
            return 'OR';
        case 'CANCEL_REJECTED' :
            return 'CR';
        case 'CANCEL_RECEIVED' :
            return 'CS';
        case 'REPLACE_REJECTED' :
            return 'RR';
        case 'REPLACE_RECEIVED' :
            return 'RS';
        case 'BOOKABLE' :
            return 'BA';
        case 'BOOKABLE' :
            return 'BA';
        case 'BOOKED' :
            return 'BK';
        case 'NOTHING_DONE' :
            return 'ND';
        case 'VALIDATION_ERROR' :
            return 'ERR';
        case undefined:
            return '###';
        case 'MC_SENT_REPLACE' :
				case 'MC_SENT_CANCEL' :
				case 'MC_SENT_ORDER' :
            return 'MC';
        default:
            return execType;
    }
}



// WEBPACK FOOTER //
// ./src/ems_monitor.jsx